export default __webpack_public_path__ + "static/media/health.ad34799d.png";